export const initialState = {
service:{
  name:null,
  id:null,
},
date:new Date(),
time:null,
location:"Any Location",
services:{},
availableServices:[],
isAvailable:null,
loading:false,
error:null
}

const APIACTIONS= {
  CALL_API: 'call-api',
  SUCCESS: 'success',
  ERROR: 'error',
}

const DATETIMESELECTIONACTION ={
  ADD_DATE:"ADD_SELECTED_DATE",
  ADD_TIME:"ADD_SELECTED_TIME"
}

const SERVICES ={
  AVAILABLE:'ADD_AVAILABLE_SERVICES',
  USER_SELECTED_SERVICE:'ADD_USER_SELECTED_SERVICE'
}


const reducer = (state,action)=>{
// console.log("action",action);
switch(action.type){
  // add date
  case DATETIMESELECTIONACTION.ADD_DATE:
    return {...state,date:action.date};

    // add time
    case DATETIMESELECTIONACTION.ADD_TIME:
      return {...state,time:action.time};

      // get all services
      case APIACTIONS.CALL_API:
        return {...state,loading:true,isAvailable:null};

        // on success call
        case APIACTIONS.SUCCESS:
          return {...state,loading:false,services:action.data,};

          //on faliure call
          case APIACTIONS.ERROR:
            return {...state,loading:false,error:action.error};
            //set available Services
          case SERVICES.AVAILABLE:
            return {...state,availableServices:action.available,isAvailable:action.isAvailable};

             //set userSelected Services
          case SERVICES.USER_SELECTED_SERVICE:
            return {...state,service:action.data};

    default:
      return state;
}
}

export const checkAvailableService = (services)=>{
  // console.log("services fdrom resuces",services)
  return services.filter(service=>service.isAvailable);
}

export const addSelectedService = (service)=>{
// check if the service still availabe
// reserve service
// promote to the next page..
//set the state 

}

export default reducer;